import * as actionTypes from './actionTypes'

const initialState = {
    orders: [],
    isOrdersLoading: false,
    error: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ORDERS_REQUESTED:
            return {
                ...state,
                isOrdersLoading: true,
                error: null,
            }

        case actionTypes.ORDERS_SUCCEED:
            return {
                ...state,
                isOrdersLoading: false,
                orders: action.orders,
            }

        case actionTypes.ORDERS_FAIL:
            return {
                ...state,
                isOrdersLoading: false,
                error: action.error,
            }

        case actionTypes.UPDATE_ORDER:
            const updatedOrders = state.orders || []
            const editedOrder = action.order

            for (let i = 0; i < updatedOrders.length; i++) {
                if (updatedOrders[i].id === editedOrder.id) {
                    console.log('update candidate:')
                    console.log(updatedOrders[i])

                    updatedOrders[i] = editedOrder

                    console.log('new value:')
                    console.log(updatedOrders[i])
                }
            }

            return {
                ...state,
                orders: updatedOrders,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/orders/reducer.js